import { DEFAULT_LOCALE, LOCALES, Locale } from "@divespots/contracts";
import i18next from "i18next";
import { initReactI18next, useTranslation } from "react-i18next";
import { de } from "./locales/de.ts";
import { en } from "./locales/en.ts";
import { fr } from "./locales/fr.ts";
import { it } from "./locales/it.ts";

export const catalogs = { de, en, fr, it } as const;

void i18next.use(initReactI18next).init({
  resources: {
    de: { translation: de },
    en: { translation: en },
    fr: { translation: fr },
    it: { translation: it },
  },
  lng: DEFAULT_LOCALE,
  fallbackLng: DEFAULT_LOCALE,
  supportedLngs: [...LOCALES],
  interpolation: { escapeValue: false },
  initAsync: false,
  returnNull: false,
});

export { i18next as i18n };

/** First browser language we support (primary subtag match), else German. */
export function bestLocale(languages: readonly string[]): Locale {
  for (const tag of languages) {
    const primary = tag.toLowerCase().split("-")[0];
    const parsed = Locale.safeParse(primary);
    if (parsed.success) return parsed.data;
  }
  return DEFAULT_LOCALE;
}

export function browserLocale(): Locale {
  if (typeof navigator === "undefined") return DEFAULT_LOCALE;
  return bestLocale(navigator.languages?.length ? navigator.languages : [navigator.language]);
}

/** The active UI/content locale; re-renders on language change. */
export function useLocale(): Locale {
  const { i18n } = useTranslation();
  const parsed = Locale.safeParse(i18n.language);
  return parsed.success ? parsed.data : DEFAULT_LOCALE;
}
